import { Environment } from '@uplift/store';

export const environment: Environment = {
  appNameSpace: 'uplift-matching',
  production: true,
  sentryDSN: process.env.NX_PUBLIC_SENTRY_DSN,
  restApi: process.env.NX_PUBLIC_REST_API,
  authUrl: process.env.NX_PUBLIC_AUTH_URL,
  patientAppUrl: process.env.NX_PUBLIC_PATIENT_APP_URL,
};
